import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { UsersThree, Microphone, ArrowUpRight, ChatCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function Circles() {
  const [rooms, setRooms] = useState([]);
  useEffect(() => { api.get("/community/rooms").then((r) => setRooms(r.data)); }, []);

  return (
    <div className="min-h-screen mesh-bg-warm pb-32" data-testid="circles-screen">
      <div className="px-6 pt-12 pb-4">
        <p className="text-xs tracking-widest uppercase text-zinc-500">Live</p>
        <h1 className="font-display text-4xl font-light tracking-tight">Find your circle.</h1>
        <p className="mt-2 text-sm text-zinc-400">Mastermind rooms · cohort sprints · founder circles.</p>
      </div>

      {/* Live banner */}
      <div className="px-6">
        <div className="glass-strong rounded-3xl p-5 relative overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-3 right-3 flex items-center gap-1 text-[10px] uppercase tracking-widest text-rose-300">
              <span className="w-1.5 h-1.5 rounded-full bg-rose-400 animate-pulse" /> Live
            </div>
          </div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500">Featured room</div>
          <div className="mt-1 font-display text-2xl font-light">"Ship in 7 Days"</div>
          <p className="text-sm text-zinc-400">Hosted by Aiyana · 47 founders building right now.</p>
          <div className="mt-4 flex items-center gap-2">
            <div className="flex -space-x-2">
              {["1027","1012","2150","1438"].map((id) => (
                <img key={id} src={`https://i.pravatar.cc/40?img=${id.slice(-2)}`} alt="" className="w-7 h-7 rounded-full border border-black/40" />
              ))}
            </div>
            <span className="text-[11px] text-zinc-500">+43 inside</span>
            <button data-testid="join-live" className="ml-auto rounded-full bg-white text-black text-xs font-medium px-3.5 py-2 active:scale-95 flex items-center gap-1">
              <Microphone size={12} weight="fill" /> Join live
            </button>
          </div>
        </div>
      </div>

      {/* Rooms */}
      <div className="mt-6 px-6">
        <h3 className="text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-3">Mastermind rooms</h3>
        <div className="space-y-2">
          {rooms.map((r, i) => (
            <motion.button
              key={r.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              data-testid={`room-${r.id}`}
              className="w-full glass rounded-2xl p-4 flex items-center gap-3 text-left active:scale-[0.99] transition"
            >
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center relative" style={{ background: `${r.color}1a` }}>
                <UsersThree size={20} weight="fill" style={{ color: r.color }} />
                {r.live > 0 && (
                  <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-rose-400 ring-2 ring-[#0a0a0a]" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{r.name}</div>
                <div className="text-[11px] text-zinc-500">{r.topic}</div>
              </div>
              <div className="text-right">
                <div className="text-[11px] font-mono-jb text-zinc-300">{r.live} live</div>
                <div className="text-[10px] text-zinc-500">{r.members} members</div>
              </div>
            </motion.button>
          ))}
        </div>
      </div>

      {/* Cohorts */}
      <div className="mt-8 px-6">
        <h3 className="text-[11px] uppercase tracking-[0.25em] text-zinc-500 mb-3">Cohort sprints</h3>
        <div className="grid grid-cols-2 gap-3">
          {[
            { name: "AI Builder Sprint", days: 14, color: "#60A5FA" },
            { name: "Founder Bootcamp", days: 28, color: "#818CF8" },
            { name: "Creator Bootcamp", days: 21, color: "#34D399" },
            { name: "Money OS", days: 14, color: "#FBBF24" },
          ].map((c) => (
            <div key={c.name} className="glass rounded-2xl p-4 relative overflow-hidden" data-testid={`cohort-${c.name}`}>
              <div className="absolute -top-8 -right-8 w-24 h-24 rounded-full blur-2xl" style={{ background: c.color, opacity: 0.18 }} />
              <ChatCircle size={18} weight="fill" style={{ color: c.color }} />
              <div className="mt-2 text-sm font-medium">{c.name}</div>
              <div className="text-[11px] text-zinc-500">{c.days}-day sprint</div>
              <div className="mt-3 flex items-center gap-1 text-[11px] text-zinc-300">
                Join <ArrowUpRight size={12} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
